import { Component, OnInit, Input, ElementRef, ViewChild, SimpleChanges, OnChanges, OnDestroy, ViewChildren, QueryList } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AdiantamentoDocumentoService } from '../service/adiantamento-documento.service';
import {
  AdiantamentoDocumento, Adiantamento, Login,
  GlobalService, FuncaoService
} from 'eddydata-lib';

@Component({
  selector: 'lib-adiantamento-documento',
  templateUrl: './adiantamento-documento.component.html'
})
export class AdiantamentoDocumentoComponent implements OnInit, OnChanges, OnDestroy {

  public ptBR: any;
  public entity: AdiantamentoDocumento;
  public entityTemp: AdiantamentoDocumento;
  public listaDocumentos: Array<any>;
  public total: number;
  protected unsubscribe: Subject<void> = new Subject();

  @Input() lista: Array<any>;
  @Input() entidade: Adiantamento;
  @Input() login: Login;

  @ViewChild('btnAdicionarDocumento') public btnAdicionarDocumento: ElementRef;
  @ViewChildren('btnsEditar') public btnsEditar: QueryList<ElementRef>;

  imaskConfig = {
    mask: Number,
    scale: 2,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ','
  };

  constructor(
    private messageService: MessageService,
    protected confirmationService: ConfirmationService,
    protected globalService: GlobalService,
    protected funcaoService: FuncaoService,
    protected documentoService: AdiantamentoDocumentoService,
  ) { }

  ngOnInit() {
    this.ptBR = this.globalService.obterDataBR();
    this.listaDocumentos = this.lista;
    this.calcularTotal();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.lista) {
      this.listaDocumentos = this.lista;
      this.calcularTotal();
    }
  }

  private desabilitarEdicao(desabilitar: boolean) {
    this.btnsEditar.forEach((btn) => btn.nativeElement.disabled = desabilitar)
    this.btnAdicionarDocumento.nativeElement.disabled = desabilitar;
  }

  public adicionarDocumento() {
    this.entity = new AdiantamentoDocumento();
    this.entity.editavel = true;
    this.entity['salvo'] = false;
    if (!this.listaDocumentos) {
      this.listaDocumentos = new Array();
    }
    this.listaDocumentos.unshift(this.entity);
    this.desabilitarEdicao(true);
  }

  public salvarDocumento(item: AdiantamentoDocumento) {
    try {
      if (!item.documento) {
        throw new Error('Informe a ficha de retenção!');
      }

      // envia a entidade para ser salva no banco -----
      if (!item.id) {
        this.entity.adiantamento = this.entidade;
        this.documentoService.inserir(item).pipe(takeUntil(this.unsubscribe))
          .subscribe((res) => {
            item.editavel = false;
            item['salvo'] = true;
            this.desabilitarEdicao(false);
          });
      } else {
        this.documentoService.atualizar(item).pipe(takeUntil(this.unsubscribe))
          .subscribe((res) => {
            item.editavel = false;
            item['salvo'] = true;
            this.desabilitarEdicao(false);
          });
      }
      this.calcularTotal();
    } catch (e) {
      this.messageService.add({ severity: 'error', summary: 'Validação', detail: e });
      throw e;
    }
  }

  public editarDocumento(item: AdiantamentoDocumento) {
    this.entityTemp = JSON.parse(JSON.stringify(item));

    this.entity = item;
    this.entity.editavel = true;
    this.entity['salvo'] = true;
    this.desabilitarEdicao(true);
  }

  public cancelarDocumento(item: AdiantamentoDocumento, index: number) {
    if (item['salvo'] && item.id === this.entityTemp?.id) {
      item.data_documento = this.entityTemp.data_documento;
      item.documento = this.entityTemp.documento;
      item.cnpj = this.entityTemp.cnpj;
      item.razao_social = this.entityTemp.razao_social;
      item.valor_documento = this.entityTemp.valor_documento;

      this.entity = item;
      this.entity.editavel = false;
    } else {
      this.listaDocumentos.splice(index, 1);
    }
    this.desabilitarEdicao(false);
  }

  public confirmarRemocao(item: AdiantamentoDocumento, index: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja remover item?',
      acceptLabel: "Sim",
      rejectLabel: "Não",
      header: 'Remoção',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.removerDocumento(item, index)
      },
    });
  }

  private removerDocumento(item: AdiantamentoDocumento, index: number) {
    if (item.id) {
      this.documentoService.remover(item.id).pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
          this.listaDocumentos.splice(index, 1);
          this.messageService.add({ severity: 'info', summary: 'Exclusão', detail: 'Registro removido com sucesso!' });
        }, error => {
          this.messageService.add({ severity: 'error', summary: 'Exclusão', detail: error.error.payload });
          throw error;
        });
    } else {
      this.listaDocumentos.splice(index, 1);
    }
    this.calcularTotal();
  }

  private calcularTotal() {
    this.total = 0;
    if (this.listaDocumentos) {
      for (const item of this.listaDocumentos) {
        this.total += +item.valor_documento;
      }
    }
  }

}
